import { render, staticRenderFns } from "./EntityBubble.vue?vue&type=template&id=2d402858&scoped=true&"
import script from "./EntityBubble.vue?vue&type=script&lang=js&"
export * from "./EntityBubble.vue?vue&type=script&lang=js&"
import style0 from "./EntityBubble.vue?vue&type=style&index=0&id=2d402858&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d402858",
  null
  
)

export default component.exports